import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { UserInterface, UserMetaInterface } from '@interface/user/user.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialUserState: BaseStoreInterface<UserInterface, UserMetaInterface> = {
  ...BaseStoreStructure,
  data: {
    id: '',
    email: '',
    profile: {
      name: '',
      lastname: '',
    },
    settings: {
      hasBillingEvent: false,
      hasConnectionEvent: false,
      hasErrorEvent: false,
      hasSecurityEvent: false,
    },
    guides: {
      completedDashboard: false,
      completedCreateApplication: false,
      completedConsumer: false,
    },
    isVerified: false,
  },
  meta: {},
};
